import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setLocaleCode } from 'utils/localeHalper';

import PropTypes from 'prop-types';
import OpacityPreLoader from '../../../../components/Common/PreLoaders/OpacityPreLoader';

const languages = [
  {
    value: 'ru-RU',
    label: 'Русский'
  },
  {
    value: 'en-US',
    label: 'English'
  }
];

class LanguagesDrop extends Component {
  constructor(props) {
    super(props);
    this.dropDownBlock = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUpdate(nextProps) {
    if (this.props.language && this.props.language !== nextProps.language) {
      window.location.reload();
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = e => {
    if (!this.dropDownBlock.current.contains(e.target)) {
      this.props.closeDropdown();
    }
  };

  render() {
    return (
      <div
        className="dropdown-menu dropdown-menu-notify"
        style={{
          minWidth: '100%'
        }}
        id="notification"
        ref={this.dropDownBlock}
      >
        {this.props.requestState.hasInProgress ? <OpacityPreLoader /> : null}
        {languages.map(item => (
          <div>
            <a
              href=""
              onClick={e => {
                e.preventDefault();
                setLocaleCode(item.value);
                location.reload();
              }}
            >
              <div
                key={`LanguagesDropItem${item.value}`}
                className="dropdown-menu-alert"
                role="none"
                style={
                  this.props.language === item.value
                    ? {
                        color: 'white',
                        backgroundColor: '#33a9f4'
                      }
                    : null
                }
              >
                <div className="media">
                  <div className="media-body media-middle">{item.label}</div>
                </div>
              </div>
            </a>
          </div>
        ))}
      </div>
    );
  }
}

LanguagesDrop.propTypes = {
  // IN
  requestState: PropTypes.shape({
    hasInProgress: PropTypes.bool.isRequired
  }).isRequired,
  language: PropTypes.string.isRequired,
  languagesApp: PropTypes.shape({}).isRequired,
  closeDropdown: PropTypes.func.isRequired
};

const mapStateToProps = () => ({});

// eslint-disable-next-line no-unused-vars
const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LanguagesDrop);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Header/Languages/LanguagesDrop.js